import * as ReactDOMClient from 'react-dom/client';
import { Provider } from 'react-redux';
import { store, persistor } from 'app/store';
import App from 'app/app';
import { PersistGate } from 'redux-persist/integration/react';

document.head
  .appendChild(document.createElement('base'))
  .setAttribute('href', '/');

const root = ReactDOMClient.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

const environments = ['production', 'staging'];
if (environments.includes(process.env.NODE_ENV)) {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}
